<template>
    <div v-if="isChecked" class="mr-2">
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="15" height="15" rx="2.8125" fill="#286EB6" />
            <rect
                x="5.65039"
                y="11.4858"
                width="9.7988"
                height="1.2"
                rx="0.6"
                transform="rotate(-60 5.65039 11.4858)"
                fill="white"
            />
            <rect
                x="6.04492"
                y="12.356"
                width="6.08967"
                height="1.2"
                rx="0.6"
                transform="rotate(-120 6.04492 12.356)"
                fill="white"
            />
        </svg>
    </div>
    <div v-if="!isChecked" class="mr-2">
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="14" height="14" rx="2.3125" fill="white" stroke="#286EB6" />
        </svg>
    </div>
</template>
<script setup>
import { onMounted, watch } from 'vue';
const props = defineProps({
    isChecked: {
        type: Boolean,
        default: false,
    },
    invert: {
        type: Boolean,
        default: false,
    },
});

watch(props.isChecked, () => {
    console.log('props.isChecked'.props.isChecked);
});

onMounted(() => {
    console.log('props', props);
});
</script>
